import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { EntregaOcurreFormNoRx } from "./form";
const EntregaOcurreFormRx = componentToRx(EntregaOcurreFormNoRx);
type Entity = models.EntregaOcurreDTOListas;
const resource = resources.EntregaOcurre;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value: Promise<Entity> | Entity;
}
class EntregaOcurreEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue() };
    }
    get id(): number  {
        const id = this.props.match.params.id;
        return Number.parseInt(id);
    }
    async getValue() {
        return await resource.GetEntrega(this.id);
    }

   
    render() {
        const props = this.props;
        const params = props.match!.params.id;
        return <EntregaOcurreFormRx value={this.state.value} />;
    }
}

export const EntregaOcurreEdit = withRouter(EntregaOcurreEditComp);     



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/edit/edit.tsx